import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import PageLoader from '@/components/PageLoader';
import Navigation from '@/components/sections/Navigation';
import Hero from '@/components/sections/Hero';
import WhyUs from '@/components/sections/WhyUs';
import WhoWeServe from '@/components/sections/WhoWeServe';
import LegacyBlueprint from '@/components/sections/LegacyBlueprint';
import Services from '@/components/sections/Services';
import SignatureDifference from '@/components/sections/SignatureDifference';
import WhyFamiliesChoose from '@/components/sections/WhyFamiliesChoose';
import Founder from '@/components/sections/Founder';
import Testimonials from '@/components/sections/Testimonials';
import LeadMagnet from '@/components/sections/LeadMagnet';
import Consultation from '@/components/sections/Consultation';
import Footer from '@/components/sections/Footer';
import Privacy from '@/pages/Privacy';
import Terms from '@/pages/Terms';

function Home() {
  useEffect(() => {
    document.title = 'Bowers Advisory Group — Financial Strategies Built for Your Legacy';
    const meta = document.querySelector('meta[name="description"]');
    const desc = 'Bowers Advisory Group is a boutique, education-first financial consulting practice offering insurance based strategies, retirement strategies, and legacy planning for families, educators, business owners, and faith-based communities.';
    if (meta) meta.setAttribute('content', desc);
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#F7F4EE] text-[#2B2B2B] antialiased">
      <PageLoader />
      <Navigation />
      <main>
        <Hero />
        <WhyUs />
        <WhoWeServe />
        <LegacyBlueprint />
        <Services />
        <SignatureDifference />
        <WhyFamiliesChoose />
        <Founder />
        <Testimonials />
        <LeadMagnet />
        <Consultation />
      </main>
      <Footer />
    </div>
  );
}

function ToastPortal() {
  return (
    <Toaster
      position="top-center"
      theme="dark"
      toastOptions={{
        style: {
          background: '#0E2238',
          color: '#F7F4EE',
          border: '1px solid rgba(182,138,53,0.35)',
          borderRadius: '2px',
          fontFamily: "'Inter', sans-serif",
        },
      }}
    />
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <ToastPortal />
    </BrowserRouter>
  );
}
